/**
 * Türkçe sözlük · ortak: birden çok ekranda geçen düğme ve durum sözcükleri.
 * Terimlerin tek karşılığı: `claude/notlar/2026-10-27-cok-dilli-arayuz-kararlar.md` §5.
 */
export const ortak = {
  kaydet: "Kaydet",
  kaydediliyor: "Kaydediliyor…",
  iptal: "İptal",
  vazgec: "Vazgeç",
  sil: "Sil",
  siliniyor: "Siliniyor…",
  kapat: "Kapat",
  duzenle: "Düzenle",
  ekle: "Ekle",
  evet: "Evet",
  hayir: "Hayır",
  tamam: "Tamam",
  devam: "Devam",
  geri: "Geri",
  yukleniyor: "Yükleniyor…",
  okunuyor: "Okunuyor…",
  yenidenDene: "Yeniden dene",
  secin: "Seçin…",
  tumu: "Tümü",
  ayrinti: "Ayrıntı",
  teknikAyrinti: "Teknik ayrıntı",
  bilinmiyor: "bilinmiyor",
  gun: (n: number) => `${n} gün`,
  /** Döviz kıyası adı (`KUR_KIYASLARI`; sözleşmedeki `ad` Türkçe kayıt adıdır). */
  kurKiyasAdi: { USD: "Dolar / TL", EUR: "Euro / TL" } as Readonly<Record<string, string>>,
};
